export const DEFAULT_SHOW_TIME_MS = 3500;

export const OPACITY_ANIMATION_TIME_MS = 300;

export const VIEWPORT_OFFSET = 20;
